import React from 'react';

interface StatusBarProps {
  palette: {
    panelBorder: string;
    panelSubText: string;
  };
  glass: React.CSSProperties;
  diagramType: 'flow' | 'sequence';
  zoomScale: number;
  nodeCount: number;
  edgeCount: number;
  participantCount: number;
  messageCount: number;
  selectedCount: number;
  canUndo: boolean;
  canRedo: boolean;
}

export function StatusBar({
  palette,
  glass,
  diagramType,
  zoomScale,
  nodeCount,
  edgeCount,
  participantCount,
  messageCount,
  selectedCount,
  canUndo,
  canRedo,
}: StatusBarProps) {
  return (
    <div className="absolute bottom-4 right-4 z-40" data-tour="status-bar">
      <div style={glass} className="backdrop-blur-md border rounded-xl px-4 py-2 shadow-xl">
        <div className="flex items-center gap-3 text-xs" style={{ color: palette.panelSubText }}>
          <span className="flex items-center gap-1.5">
            <span className="w-1.5 h-1.5 bg-emerald-500 rounded-full animate-pulse" />
            Live
          </span>
          <span style={{ color: palette.panelBorder }}>|</span>
          <span>{Math.round(zoomScale * 100)}%</span>
          <span style={{ color: palette.panelBorder }}>|</span>
          {diagramType === 'flow' ? (
            <>
              <span>{nodeCount} nodes</span>
              <span style={{ color: palette.panelBorder }}>|</span>
              <span>{edgeCount} edges</span>
            </>
          ) : (
            <>
              <span>{participantCount} participants</span>
              <span style={{ color: palette.panelBorder }}>|</span>
              <span>{messageCount} messages</span>
            </>
          )}
          {selectedCount > 0 && (
            <>
              <span style={{ color: palette.panelBorder }}>|</span>
              <span className="text-indigo-400">{selectedCount} selected</span>
              <span style={{ color: palette.panelSubText }}>Del to remove</span>
            </>
          )}
          {(canUndo || canRedo) && (
            <>
              <span style={{ color: palette.panelBorder }}>|</span>
              <span style={{ color: palette.panelSubText }}>
                {canUndo && 'Ctrl+Z'}
                {canUndo && canRedo && ' · '}
                {canRedo && 'Ctrl+Shift+Z'}
              </span>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
